/**
 * Created by mly on 2018/5/17.
 */
import Util from '../../../libs/util';
import FlowUtil from '../../../libs/flow_util';
import UserFlowBase from '../../components/flow/user_flow_base.vue';
import TravelOrderEdit from '../components/travel_order_edit.vue';
import TravelOrderExpand from '../components/travel_order_expand.vue';
export const budget_types = [
  {
    budget_type:'railway_air',
    budget_amount:'',
    text: '火车票/机票'
  },
  {
    budget_type:'hotel',
    budget_amount:'',
    text: '酒店'
  },
  {
    budget_type:'traffic',
    budget_amount:'',
    text: '市内交通'
  },
  {
    budget_type:'other',
    budget_amount:'',
    text: '其他'
  }
]
export default {
  components: { UserFlowBase, TravelOrderEdit, TravelOrderExpand },
  data() {
    return {
      budget_types: JSON.parse(JSON.stringify(budget_types)),
      order_type_map: {
        0: '培训学习',
        1: '团建',
        2: '其他',
        3: '商务洽谈/出行'
      },
      params: {
        per_page: 10,
        page: 1,
        search_type: 'mine',
        search: ''
      },
      page_info: {
        current: 1,
        total: 0,
        page_size: 10
      },
      loading: false,
      deleting_index: 0,
      travel_orders: [],
      expand_column: {
        title: '展开',
        type: 'expand',
        align: 'center',
        width: 60,
        render: (h, params) => {
          return h(TravelOrderExpand, {
            props: {
              travel_order: params.row
            }
          })
        }
      },
      handle_column:  {
        title: '操作',
        width: 85,
        render: (h, params) => {
          const row = params.row;
          const items = [];
          if (FlowUtil.canEdit(row, this.cur_customer)) {
            items.push(h('DropdownItem', {
              props: {name: 'edit'}
            }, '编辑'));
          }
          if (FlowUtil.canEdit(row, this.cur_customer)) {
            items.push(h('DropdownItem', {
              props: {name: 'delete', divided: true}
            }, '废弃'));
          }
          if (!items.length) {
            return h('div', '-');
          }

          return h('Dropdown', {
            props: {
              trigger: 'click',
              placement: 'left'
            },
            on: {
              'on-click': (event_name) => {
                this.handleEvent(event_name, row, params.index);
              }
            }
          }, [
            h('Button', [
              h('span', ' 操作'),
            ]),
            h('DropdownMenu', {
              slot: 'list'
            }, items)
          ]);
        }
      }
    }
  },
  computed: {
    cur_customer() {
      return this.$store.state.cur_customer;
    },
    columns() {
      let columns = [];
      columns.push(this.expand_column);
      columns = columns.concat([
        {
          title: '差旅事由',
          align: 'center',
          minWidth: 80,
          render: (h, params) => {
            return h('span', this.order_type_map[params.row.order_type])
          }
        },
        {
          title: '行程人员',
          align: 'center',
          minWidth: 140,
          render: (h, params) => {
            const row = params.row;
            const names = [];
            row.items.forEach(item => {
              item.passengers.forEach(p => {
                if (!names.includes(p.account)) {
                  names.push(p.account);
                }
              });
            })
            return h('span', names.join(','))
          }
        },
        {
          title: '行程名称',
          align: 'center',
          minWidth: 140,
          key: 'name'
        },
        {
          title: '行程数量',
          align: 'center',
          minWidth: 140,
          render: (h, params) => {
            return h('span', params.row.items.length);
          }
        },
        {
          title: '预算',
          align: 'center',
          minWidth: 140,
          render: (h, params) => {
            const all_budgets_arr = params.row.items.reduce((arr, item) => {
              return arr.concat(item.budgets || [])
            }, [])
            const total = all_budgets_arr.reduce((total, item) => {
              return math.eval(`${total}+${item.budget_amount || 0}`)
            }, 0).toFixed(2)
           
            return h('span', Util.formatPrice(total));
          }
        },
        {
          title: '状态',
          width: 125,
          key: 'status',
          render: (h, params) => {
            const row = params.row;
            const user_flow = row.user_flow;
            if (user_flow) {
              return h(UserFlowBase, {
                props: {
                  user_flow: user_flow,
                  model: row,
                  title: row.name
                }
              })
            } else {
              return h('div', '-');
            }
          }
        }
      ]);
      columns.push(this.handle_column);
      return columns;
    }
  },
  methods:{
    editNewTravelOrder() {
      this.$refs.editor.editNew();
    },
    editTravelOrder(travel_order) {
      this.$refs.editor.edit(travel_order);
    },
    updateTravelOrder(travel_order) {
      Util.insertOrUpdateArrayItem(this.travel_orders, travel_order, true);
    },
    handleEvent(event_name, travel_order, index) {
      switch (event_name) {
        case 'edit':
          this.editTravelOrder(travel_order);
          break;
        case 'delete':
          this.deleteTravelOrder(travel_order, index);
          break;
        default:
          this.$Message.error('未定义操作!');
          break;
      }
    },
    beforeSearch() {
      this.params.page = 1;
      this.loading = true;
      this.travel_orders = [];
    },
    pageChange(new_page) {
      this.params.page = new_page;
      this.loading = true;
       this.$refs.searchBtn.doAjax(true);
    },
    doSearch() {
      this.params.page = 1
      this.$refs.searchBtn.doAjax();
    },
    handleData(data) {
      this.loading = false;
      this.travel_orders = data.travel_orders;
      this.page_info.current = data.cur_page;
      this.page_info.page_size = data.per_page;
      this.page_info.total = data.total_count;
    },
    handleFail(e) {
      this.loading = false;
      this.$Modal.warning({
        title: '错误',
        content: e.message
      });
    },
    deleteTravelOrder(travel_order, index) {
      this.$Modal.confirm({
        title: '提示',
        content: '你确定要废弃吗?',
        onOk: () => {
          this.deleting_index = index;
          Util.ajax.post(Util.api.delete_travel_order, {
            id: travel_order.id
          }).then((response) => {
            return response.data;
          }).then((res) => {
            this.deleting_index = 0;
            if (res.code === 1) {
              this.travel_orders.splice(index, 1);
            } else {
              setTimeout(() => {
                this.$Modal.warning({
                  title: '错误',
                  content: res.msg
                });
              }, 500);
            }
          }).catch((e) => {
            this.deleting_index = 0;
            setTimeout(() => {
              this.$Modal.warning({
                title: '错误',
                content: e.message
              });
            }, 500);
          });
        }
      });
    }
  }
}
